import React from 'react'
import Footer from './Footer'

const Tuboplastic = () => {
    return (
        <>
            <div className='heading'>
                <h1>Tuboplasty Micro Surgeries </h1>
                <p>Home / Tuboplasty Micro Surgeries</p>
            </div>

            <div className='desiese'>

                <div className='desiese1'>


                    <p><strong>Indications:</strong><br/>Tuboplasty microsurgery may be recommended for women experiencing infertility due to fallopian tube blockages or damage. Common indications include:</p>
                    <ul>
                        <li><strong>Tubal Blockage:</strong> Blockages in the fallopian tubes can prevent the passage of eggs from the ovaries to the uterus, leading to infertility.</li>
                        <li><strong>Tubal Damage:</strong> Injuries to the fallopian tubes, such as scarring from previous infections or surgeries, can impair their function and hinder conception.</li>
                        <li><strong>Tubal Ligation Reversal:</strong> In some cases, women who have undergone tubal ligation (a permanent form of birth control) may desire to have their fertility restored through tubal reversal surgery.</li>
                    </ul>
                    <p><strong>Procedure:</strong><br/>During tuboplasty microsurgery:</p>
                    <ol>
                        <li><strong>Microscopic Visualization:</strong> The surgeon uses a high-powered surgical microscope to magnify the fallopian tubes and surrounding structures, allowing for precise visualization and manipulation of the delicate tissues.</li>
                        <li><strong>Fallopian Tube Assessment:</strong> The surgeon evaluates the condition of the fallopian tubes to identify any blockages, damage, or abnormalities.</li>
                        <li><strong>Tubal Repair or Reconstruction:</strong> Depending on the specific findings, the surgeon may perform various techniques to repair or reconstruct the fallopian tubes. This may involve removing scar tissue, opening blocked portions of the tubes, or reconnecting segments that have been severed.</li>
                        <li><strong>Microsurgical Techniques:</strong> Specialized microsurgical instruments are used to perform intricate procedures with minimal trauma to the surrounding tissues. Fine sutures are used to meticulously repair the fallopian tubes.</li>
                        <li><strong>Confirmation of Patency:</strong> After the repair or reconstruction is completed, the surgeon may use techniques such as dye injection or laparoscopic visualization to confirm that the fallopian tubes are open and functioning properly.</li>
                    </ol>


                </div>



                <div className='desiese2'>
                    <h1>Dr. Mansi Shukul</h1>
                    <h2>Obstetrician, Gynecologist, & Infertility
                        M.B.B.S , D.G.O. (A.M.U) D.N.B. (Apollo Hospital).
                    </h2>
                    <p>F.M.A.S (Fellowship in Minimal Access Surgery).</p>
                    <p>M.R.C.O.G. (UK), M.N.A.M.S.</p>
                    <p>Ex. SR at Sunder Lal Jain Hospital, Delhi.</p>
                    <p>Ex. SR at Career Institute of Medical Science, Lucknow.</p>
                    <p>Ex. Laparoscopic Consultant at Lakshmi Madhavan Hospital, Tamil Nadu.</p>


                </div>

                <div className='desiese3'>
                    <h1>Dr. Garima Gupta</h1>
                    <h2>Obstetrician, Gynecologist, & Infertility
                        M,B.B.S , D.G.O. ,(Lady Hardinge , New Delhi).</h2>

                    <p>D.N.B. (D.D.U Hospital, New Delhi)</p>
                    <p>F.I.C.O.G., M.R.C.O.G. (UK), M.N.A.M.S.</p>
                    <p>Ex. SR at D.D.U Hospital, New Delhi.</p>
                    <p>Ex. SR at Dr. RML Hospital & P.G.I.M.E.R., New Delhi.</p>
                    <p>Ex. Consultant at Srijan Fertility Institute, Patna.</p>

                </div>
            </div>

            <br />

            <Footer />
        </>
    )
}

export default Tuboplastic
